import { gql, useQuery } from '@apollo/client';

const GET_CLIENT_TRANSACTIONS_QUERY = gql`
  query GetClientTransactions {
    getClientTransactions {
      id
      amount
      price
      units
      status
      subType
      subTypeDetail
      tradeDate
      securityId
      securityName
      accountId
      note
    }
  }
`;

export const useGetClientTransactionsWallet = () => {
  return useQuery(GET_CLIENT_TRANSACTIONS_QUERY);
};
